import * as yup from "yup";
import { isRequired, mustBeNumber, mustBePositive } from "./messages";

const isNumberOrNull = (fieldName: string, unit?: string) =>
	yup
		.number()
		.nullable()
		.typeError(mustBeNumber(fieldName, unit))
		.min(0, mustBePositive(fieldName));

const allNamedFileFieldsComplete = yup
	.array()
	.of(
		yup.object().shape({
			country: yup.string(),
			link: yup.string(),
			name: yup.string()
		})
	)
	.nullable()
	.required(isRequired("All documents should have a country, name, and link associated with them"));

const allCountryFileFieldsComplete = yup
	.array()
	.of(
		yup.object().shape({
			country: yup.string(),
			datasheet: yup.string()
		})
	)
	.nullable()
	.required(isRequired("All documents should have a country and link associated with them"));

export const IngredientValidation = yup.object().shape({
	// name: yup.string().required(isRequired("Ingredient Name")),
	jf_display_name: yup
		.string()
		.required(isRequired("Ingredient Name"))
		.min(1, "Ingredient name cannot be empty"),
	cost: isNumberOrNull("Cost", "per unit"),
	df_energy_kcal: isNumberOrNull("Energy (kcal)", "kcal"),
	// allergens: allNamedFileFieldsComplete,
	// certifications: allNamedFileFieldsComplete,
	// datasheets: allCountryFileFieldsComplete,
	df_protein: isNumberOrNull("Protein", "grams"),
	df_carbohydrate: isNumberOrNull("Carbohydrate", "grams"),
	df_fiber: isNumberOrNull("Fiber", "grams"),
	df_sugar: isNumberOrNull("Sugar", "grams"),
	df_calcium: isNumberOrNull("Calcium", "mg"),
	df_vitamin_d2_d3: isNumberOrNull("Vitamin D2/D3", "IU"),
	df_vitamin_c: isNumberOrNull("Vitamin C", "mg"),
	df_cholesterol: isNumberOrNull("Cholesterol", "mg"),
	df_fatty_acid_total_saturated: isNumberOrNull("Saturated Fat", "grams"),
	df_fatty_acid_total_trans: isNumberOrNull("Trans Fat", "grams"),
	df_iron: isNumberOrNull("Iron", "mg"),
	df_potassium: isNumberOrNull("Potassium", "mg"),
	df_sodium: isNumberOrNull("Sodium", "mg")
});
